export default __webpack_public_path__ + "static/media/faci01.fae47a67.jpg";